import { Box, Typography } from "@mui/material";
import { Check } from "@mui/icons-material";
import { theme } from "src/assets/theme";
import { useIsMobile } from "src/hooks/useIsMobile";
import { useTranslation } from "react-i18next";
import { useProduct } from "src/context/ProductProvider";
import { productInformationArray } from "src/constants/producttInformation";

interface Props {
  estimatedLoss?: number | null;
}

const InformationArray = ({ estimatedLoss }: Props) => {
  const isMobile = useIsMobile();
  const { t } = useTranslation();
  const product = useProduct((p) => p.slug);

  const array = productInformationArray[product];

  return array.map((i) => (
    <Box key={i} display="flex" gap={1} alignItems="center">
      <Check sx={{ color: theme.palette.primary.main }} fontSize="medium" />
      <Typography variant={isMobile ? "body2" : "body1"}>
        {t(i, { estimatedLoss })}
      </Typography>
    </Box>
  ));
};

export default InformationArray;
